import { requireAuth } from "@/features/auth";
import { consumePostAuthRedirect } from "@/features/auth/post-auth-redirect";
import { ACTIVE_PROJECT_SLUG_KEY, ACTIVE_WORKSPACE_SLUG_KEY } from "@/lib/local-storage.consts";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    await requireAuth();

    // CR-288 D2: the post-auth landing (auth comes back to the app root when
    // the provider drops the return-to path) honours a stored return-to once.
    const returnTo = consumePostAuthRedirect();
    if (returnTo) {
      throw redirect({ href: returnTo, replace: true });
    }

    const activeWorkspaceSlug = localStorage.getItem(ACTIVE_WORKSPACE_SLUG_KEY);
    const activeProjectSlug = localStorage.getItem(ACTIVE_PROJECT_SLUG_KEY);

    if (activeWorkspaceSlug && activeProjectSlug) {
      throw redirect({
        to: "/workspaces/$slug/projects/$projectSlug",
        params: { slug: activeWorkspaceSlug, projectSlug: activeProjectSlug },
      });
    }

    if (activeWorkspaceSlug) {
      throw redirect({
        to: "/workspaces/$slug",
        params: { slug: activeWorkspaceSlug },
      });
    }

    throw redirect({ to: "/workspaces" });
  },
});
